import { SchemaField } from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  variableDisplayName,
  variableTypeName,
} from "@redotech/redo-flows-core-schema-common/type-system/variable-display";
import { TextRedoListItem } from "./arbiter-components/list/redo-list";

/**
 * Floor for the badge column, so the short labels most rows carry line up. Set
 * in px: a rem would widen the column — and wrap the description sooner — for
 * anyone whose browser font is larger than the default.
 */
const TYPE_BADGE_MIN_WIDTH = "72px";

/** One variable-picker row: name, description, and what the value holds. */
export function variableListItem<T>(
  field: SchemaField,
  value: T,
): TextRedoListItem<T> {
  const typeName = variableTypeName(field.dataType);
  return {
    id: field.key,
    type: "text",
    text: variableDisplayName(field),
    supportingText: field.documentation,
    wrapSupportingText: true,
    ...(typeName
      ? {
          infoBadge: { text: typeName, color: "gray" as const },
          infoBadgeMinWidth: TYPE_BADGE_MIN_WIDTH,
        }
      : {}),
    value,
  };
}
